// /**
//  * Converts a given date to a localized date and time string.
//  * @param {string|Date} date - The date to be formatted (can be a string or Date object).
//  * @param {Object} [options] - Optional Intl.DateTimeFormat options for date and time formatting.
//  * @returns {string} Localized date and time string or "Invalid Date" if the input is invalid.
//  */
// export const toLocalDateTime = (date, options = {}) => {
//     try {
//         const dateObject = new Date(date);
//         if (isNaN(dateObject)) {
//             return 'Invalid Date';
//         }
//         return dateObject.toLocaleString(undefined, options);
//     } catch (error) {
//         ////console.error('Error in toLocalDateTime:', error);
//         return 'Invalid Date';
//     }
// };


/**
 * Converts a given date to a localized date and time string in the format: "Aug 26, 2024, 09:54PM".
 * @param {string|Date} date - The date to be formatted (can be a string or Date object).
 * @returns {string} Localized date and time string or "Invalid Date" if the input is invalid.
 */
export const toLocalDateTime = (date) => {
    try {
        const dateObject = new Date(date);
        if (isNaN(dateObject)) {
            return 'Invalid Date';
        }
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',  
            day: '2-digit',  
            year: 'numeric', 
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: true      // 12-hour format with AM/PM
        }).format(dateObject).replace(',', '');
    } catch (error) {
        return 'Invalid Date';
    }
};
